/** Shared Status Board surface tokens — match approved comps (16–18px cards). */
export const statusBoardCardClass =
  'gap-0 overflow-hidden rounded-[18px] border border-border bg-card py-0 shadow-[var(--shadow-card)]';

export const statusBoardCardPadClass = 'p-4 md:p-5 md:px-[22px]';

export const statusBoardSectionTitleClass =
  'min-w-0 break-words text-[19px] font-bold leading-tight tracking-tight text-foreground';

export const statusBoardMetaClass =
  'text-[12px] text-muted-foreground md:text-[13px]';
